import styled from 'styled-components';
import { Error } from '@styled-icons/boxicons-regular/Error';
import { UserPlus } from '@styled-icons/boxicons-regular/UserPlus';
import { Button } from 'antd';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.waterBlue};
  padding: 1rem 1.5rem;

  & > div.error-content {
    display: flex;
    align-items: center;
  }

  & > button {
    margin-bottom: 0.5rem;
  }
`;

export const ErrorIcon = styled(Error)`
  width: 1rem;
  color: ${({ theme }) => theme.colors.red};
  margin-right: 0.5rem;
`;

export const AddUserButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const AddUserIcon = styled(UserPlus)`
  width: 1.25rem;
  margin-right: 0.5rem;
`;

export const AddUserContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem;
  margin-bottom: 1rem;

  &:first-child {
    padding: 1rem;
  }

  & > .hefesto-title {
    margin-bottom: 1.5rem;
  }
`;
